<span id="total-documents-container">
  <span>{{ totalDocuments }} Total Documents</span>
</span>
